import React from 'react';

export interface KpiProps {
  /** Short label above the number (e.g. "Просрочени"). */
  label: React.ReactNode;
  /** The big number itself. Can be a string ("8/12") or a number. */
  value: React.ReactNode;
  /** Optional small line under the value (e.g. "за този месец"). */
  hint?: React.ReactNode;
  /** Optional icon at the top right. */
  icon?: React.ReactNode;
  /** Highlight tone for the value. Default neutral; "warning" for due-soon, etc. */
  tone?: 'default' | 'success' | 'warning' | 'danger';
  /** Make the whole card a click target (e.g. drill into filtered list). */
  onClick?: () => void;
}

const TONE_CLASS: Record<NonNullable<KpiProps['tone']>, string> = {
  default: '',
  success: 'vc-kpi--success',
  warning: 'vc-kpi--warning',
  danger:  'vc-kpi--danger',
};

/**
 * KPI card — big number, small label, optional hint. Used in horizontal
 * dashboard strips. Click handler makes the whole card a button.
 */
export const Kpi: React.FC<KpiProps> = ({
  label, value, hint, icon, tone = 'default', onClick,
}) => {
  const content = (
    <>
      <div className="vc-kpi__head">
        <span className="vc-kpi__label">{label}</span>
        {icon && <span className="vc-kpi__icon">{icon}</span>}
      </div>
      <div className="vc-kpi__value">{value}</div>
      {hint && <div className="vc-kpi__hint">{hint}</div>}
    </>
  );

  const className = `vc-kpi ${TONE_CLASS[tone]} ${onClick ? 'vc-kpi--clickable' : ''}`;

  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={className}>
        {content}
      </button>
    );
  }
  return <div className={className}>{content}</div>;
};
